<template>
  <section
    class="instance-properties board-component bg-white"
    :class="{
      'instance-properties--full': activeGlobalData || isMediaStorageOpen,
      'instance-properties--fluid': activeGlobalData,
      'instance-properties--expanded': isExpanded && !activeGlobalData,
    }"
    :style="{ zIndex: modalBeingUnpublished && '2' }"
  >
    <div
      class="instance-properties__mask"
      @click="cancelGlobal"
    ></div>
    <div class="instance-properties__header">
      <h2 class="instance-properties__title f-16 p-600 no-select text-primary">
        <IconSettings
          v-if="instance.module === 'PageSettings'"
          class="text-primary"
        />
        <IconDashboard
          v-else
          class="text-primary"
        />
        {{ instanceName }}
      </h2>
      <button
        type="button"
        class="close"
        @click="closeEditPanel"
      >
        <IconClose size="xs" />
      </button>
    </div>
    <div class="instance-properties__body">
      <Tabs :tab-list="tabList" />
      <div
        v-if="container.type === 'modals'"
        class="instance-properties__actions custom-scrollbar"
      >
        <button
          class="btn-sm btn-block w-75 mt-3 mx-auto"
          :class="{ 'btn-outline-danger': container.isPublished }"
          :disabled="!container.isPublished"
          @click="setModalBeingUnpublished(container)"
        >
          DESATIVAR POP-UP
        </button>
      </div>
    </div>
    <div
      v-if="activeGlobalData"
      class="instance-properties__actions action-buttons"
    >
      <button
        class="btn btn-white btn-secondary"
        :class="{ 'btn-danger': hasGlobalChanges && !instance.isDirty }"
        @click="cancelGlobal"
      >
        Voltar {{ cancelEditionAction }}
      </button>
      <button
        class="btn btn-secondary"
        :disabled="!hasGlobalChanges || !!errors.length"
        @click="saveActiveGlobal"
      >
        <span
          v-show="errors.length"
          class="slb-tooltip"
        >
          <ul>
            <li
              v-for="(error, index) in errors"
              :key="index"
              v-html="error"
            ></li>
          </ul>
        </span>
        Salvar alterações
      </button>
      <!--
        This is just temporary. In the future, there'll be no external global
        instance edition, its properties will only be edited in its own editor, which will have
        a fluid navigation towards its origin page. For now, there's gotta be a way for the user
        to save its global instance editions without publishing it and there's no way to develop
        a fluid navigation between page's properties to global's properties, then back to page's.
        In the future, here'll be the global instance settings that are related to the page.
        like which global is gonna be served, exhibition conditions and a navigation button
        to the global editor.
      -->
      <button
        v-if="activeExternalGlobalInstance"
        class="btn btn-secondary"
        :disabled="!instance.isDirty || !!errors.length"
        @click="publishActiveGlobalInstance"
      >
        Publicar alterações
      </button>
    </div>
    <div
      v-if="!activeGlobalData"
      class="instance-properties__expand-button"
    >
      <button
        class="text-primary is-size-smaller no-outline"
        @click="isExpanded = !isExpanded"
      >
        <IconArrow
          :title="isExpanded ? 'Recolher' : 'Expandir'"
          :direction="isExpanded ? 'right' : 'left'"
          size="sm"
        />
      </button>
    </div>
    <!-- Modal "Desativar" -->
    <div
      v-show="modalBeingUnpublished !== null"
      class="publish-modal-modal"
      @click="setModalBeingUnpublished(null)"
    >
      <div
        class="publish-modal-modal__content"
        @click.stop
      >
        <div class="publish-modal-modal__content__header">
          <label
            class="btn-close"
            @click="setModalBeingUnpublished(null)"
          >
            <i class="icon icon-close icon-16"></i>
          </label>
          <IconWarning
            class="text-warning"
            size="lg"
          />
          <h2>Desativar</h2>
        </div>

        <div class="publish-modal-modal__content__text">
          <p>
            Ao <b>desativar</b> seu pop-up, ele não será mais exibido para seus
            usuários. Deseja continuar?
          </p>
        </div>

        <div class="publish-modal-modal__content__buttons">
          <button
            class="btn btn-secondary btn-white"
            type="button"
            @click="setModalBeingUnpublished(null)"
          >
            Não, cancelar
          </button>
          <button
            class="btn btn-secondary"
            type="submit"
            @click="unpublishModal()"
          >
            Sim, quero desativar!
          </button>
        </div>
      </div>
    </div>
    <!-- GlobalData "Cancelar" -->
    <div
      v-if="exiting"
      class="modal"
      role="dialog"
      aria-hidden="true"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Você fez algumas alterações.</h5>
            <button
              type="button"
              class="close align-self-start"
              @click="closeCancelModal"
            >
              <IconClose />
            </button>
          </div>
          <div class="modal-body">
            Deseja salvar as alterações antes de fechar?
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-white mr-auto"
              @click="cancelActiveGlobal"
            >
              Descartar alterações
            </button>
            <button
              id="leaveUnsavedSettings"
              class="btn btn-secondary"
              @click="saveClose"
            >
              Salvar alterações
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';

import * as Modules from '@/modules';
import ModalModules from '@/modules/modals';
import GlobalDataModules from '@/modules/global-data';
import Tabs from '@/components/Tabs.vue';
import IconClose from '@/components/icons/IconClose.vue';
import IconWarning from '@/components/icons/IconWarning.vue';
import IconDashboard from '@/components/icons/IconDashboard.vue';
import IconSettings from '@/components/icons/IconSettings.vue';
import IconArrow from '@/components/icons/IconArrow.vue';
import presets from '@/store/dicts/presets';
import modalPresets from '@/store/dicts/modalPresets';
import extendMetadata from '@/helpers/extendMetadata';
import getMetadataFields from '@/helpers/getMetadataFields';
import * as UiTypes from '@/ui-types';

const initialState = () => ({
  movedGroups: {},
  modalBeingUnpublished: null,
  errors: [],
  exiting: false,
});

export default {
  name: 'InstanceProperties',
  components: {
    Tabs,
    IconClose,
    IconWarning,
    IconDashboard,
    IconSettings,
    IconArrow,
  },
  data() {
    return {
      UiTypes,
      isExpanded: false,
      expandedGroups: [],
      ...initialState(),
    };
  },
  computed: {
    activeEditableGroup() {
      return this.activeGlobalData ?? this.activeInstance;
    },
    instance() {
      if (this.activeGlobalData) {
        return this.$store.getters.globalData(this.activeEditableGroup);
      }
      // TODO: Refact instance property names to use instance from mapGetters
      return this.$store.getters.instance(this.activeEditableGroup);
    },
    cancelEditionAction() {
      if (this.hasGlobalChanges) {
        if (this.instance.id.includes('Creating')) {
          return 'sem criar';
        }
        return 'sem alterar';
      }
      return '';
    },
    isGlobal() {
      return this.activeGlobalData || this.activeExternalGlobalInstance;
    },
    hasGlobalChanges() {
      if (!this.isGlobal) {
        return false;
      }

      const toCompare = this.activeGlobalData
        ? this.activeGlobalDataUnedited
        : this.globalInstance(this.activeEditableGroup);

      return !isEqual(this.instance, toCompare);
    },
    presets() {
      return this.container.type === 'modals' ? modalPresets : presets;
    },
    instanceName() {
      if (this.isGlobal) {
        return `${this.instance.id.includes('Creating') ? 'Criar' : 'Editar'}
          ${this.instance.title || this.instance.name}`;
      }

      const module = this.presets.find(
        (preset) => preset.module === this.instance.module,
      );
      return module?.name || this.instance.name;
    },
    instanceId() {
      return `${this.instance.module}-${this.activeEditableGroup}`;
    },
    DOMInstanceId() {
      return `#${this.instanceId}`;
    },
    moduleList() {
      if (this.activeGlobalData) {
        return GlobalDataModules;
      }
      if (this.container.type === 'modals') {
        return ModalModules;
      }
      return Modules;
    },
    module() {
      return this.moduleList[this.instance.module];
    },
    metadata() {
      return extendMetadata(this.module.metadata);
    },
    groups() {
      if (
        this.instance.module !== 'PageSettings' &&
        !this.instance.module.includes('Global')
      ) {
        if (this.metadata.tabs) {
          const metadataClone = cloneDeep(this.metadata);
          metadataClone.tabs[0].groups.push(this.instanceIdGroup);
          return metadataClone.tabs;
        }
        return [...this.metadata.groups, this.instanceIdGroup];
      }
      return this.metadata.tabs || this.metadata.groups;
    },
    tabList() {
      return this.getVisibleMetadata(this.groups);
    },
    instanceIdGroup() {
      return {
        name: 'instanceInfo',
        label: 'Dados do módulo',
        instanceInfo: true,
        fields: [
          {
            name: 'moduleId',
            type: 'ModuleId',
            label: 'ID do módulo',
            value: this.DOMInstanceId,
          },
        ],
      };
    },
    metaDataKeyValue() {
      const allFields = getMetadataFields(this.metadata);
      const metaDataKeyValue = {};

      allFields.forEach(({ name }) => {
        metaDataKeyValue[name] = this.instance.data[name];
      });

      return metaDataKeyValue;
    },
    showCollapseButton() {
      return this.groups.length > 1;
    },
    ...mapState([
      'globalInstances',
      'activeGlobalData',
      'activeGlobalDataUnedited',
      'activeInstance',
      'activeInstanceExpandedGroup',
      'customerSettings',
      'isMediaStorageOpen',
    ]),
    ...mapGetters([
      'activePage',
      'container',
      'globalInstance',
      'activeExternalGlobalInstance',
      'hasLetsbookIntegration',
      'hasCRMIntegration',
    ]),
  },
  watch: {
    instance: {
      handler() {
        // Reset component data when instance change and trigger first validation
        Object.assign(this.$data, initialState());
        this.instanceValidate();
      },
      immediate: true,
    },
  },
  mounted() {
    this.$watch('instance', {
      handler() {
        this.instanceValidate();
      },
      deep: true,
    });
  },
  methods: {
    instanceValidate() {
      this.errors = [];
      this.tabList.forEach((group) => {
        if (group.fields) {
          group.fields.forEach((field) => {
            if (typeof field.validate === 'function') {
              const { error } = field.validate({
                getters: this.$store.getters,
                ...this.instance,
              });
              if (error) {
                this.errors.push(error);
              }
            }
          });
        }
      });
    },
    copyData(data) {
      let copyText = this.$refs[`instanceId-${data.name}`];
      if (copyText.length > 0) {
        [copyText] = copyText;
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        document.execCommand('copy');
      }
    },
    checkConditionalVisibility({ isEnabled }) {
      if (isEnabled && typeof isEnabled === 'function') {
        return isEnabled({
          ...this.metaDataKeyValue,
          ...this.customerSettings,
          instance: this.instance,
          page: this.activePage || {},
          hasLetsbookIntegration: this.hasLetsbookIntegration,
          hasCRMIntegration: this.hasCRMIntegration,
        });
      }
      return true;
    },
    getVisibleMetadata(groups) {
      const visibleGroups = groups.filter((group) =>
        this.checkConditionalVisibility(group),
      );

      return visibleGroups.map((group) => {
        if (group.fields) {
          return {
            ...group,
            fields: group.fields.filter((field) =>
              this.checkConditionalVisibility(field),
            ),
          };
        }

        const arrayKey = ['tabs', 'groups'].find((key) => {
          return group[key];
        });
        const childGroups = group[arrayKey];
        const visibleChildren = this.getVisibleMetadata(childGroups);

        return { ...group, [arrayKey]: visibleChildren };
      });
    },
    setModalBeingUnpublished(modalBeingUnpublished) {
      this.modalBeingUnpublished = modalBeingUnpublished;
    },
    unpublishModal() {
      this.$store
        .dispatch('setGlobalInstanceStatus', {
          global: this.modalBeingUnpublished,
          isPublished: false,
          endpoint: 'modals',
        })
        .then(() => {
          this.setModalBeingUnpublished(null);
        });
    },
    saveClose() {
      this.saveActiveGlobal();
      this.toggleActiveInstance(null);
    },
    cancelGlobal() {
      if (this.hasGlobalChanges) {
        this.exiting = true;
      } else {
        this.cancelActiveGlobal();
      }
    },
    closeCancelModal() {
      this.exiting = false;
    },
    closeEditPanel() {
      if (this.activeGlobalData) {
        this.cancelGlobal();
      } else {
        this.toggleActiveInstance(null);
      }
    },
    ...mapActions([
      'saveActiveGlobal',
      'cancelActiveGlobal',
      'toggleActiveInstance',
      'publishActiveGlobalInstance',
    ]),
  },
};
</script>

<style scoped lang="scss">
.instance-properties {
  box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.15);
  right: 8px;
  top: 0;
  width: 450px;
  padding: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  position: fixed;
  transition: width 0.3s ease-in-out;

  &--full {
    right: 0;
    margin: 0;
    width: 563px;
    height: calc(100vh - 24px);
    z-index: 2000;
    transition: 0.15s width;

    .instance-properties__body {
      height: calc(100% - 72px - 75px); // menos altura do header e actions
    }

    .instance-properties__mask {
      transition: 0.15s width, 0.15s right;
      right: 563px;
      width: calc(100vw - 563px);
      background-color: rgba($lb-black, 0.75);
    }
  }

  &--fluid {
    .custom-scrollbar {
      padding: 30px 0;
    }

    .instance-properties__title {
      position: relative;
      padding: 0 55px;

      .icon {
        position: absolute;
        top: 50%;
        left: 32px;
        transform: translate(-50%, -50%);
      }
    }
  }

  &--expanded {
    width: 780px;

    .instance-properties__body {
      .tabs {
        ::v-deep {
          .ui-type-area {
            height: 360px;
          }
        }
      }
    }
  }

  &__mask {
    content: '';
    position: fixed;
    width: inherit;
    height: inherit;
    right: 15px;
    top: 0;
    z-index: -1;
  }

  &__header {
    padding: 20px 30px 15px;
    display: flex;
    justify-content: space-between;

    .close {
      width: 32px;
      height: 32px;
      border-radius: 4px;
      border: 1px solid $lb-gray;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  &__body {
    height: calc(100% - 72px); // menos altura do header
  }

  &__expand-button {
    height: 100%;
    position: absolute;
    display: flex;
    align-items: center;

    button {
      margin-left: 1px;
      background: $white;
      border-radius: 4px;

      &:hover {
        outline: 1px solid $gray-30;
      }
    }
  }

  .when-global-module {
    padding: 10px 18px 24px 30px;
  }

  .custom-scrollbar {
    flex-grow: 1;
    margin: 0;
    overflow: overlay;
  }

  &__title {
    overflow: hidden;
    background-color: $lb-white;
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: $lb-medium;

    .icon {
      margin-right: 5px;
    }
  }

  &__content {
    border-bottom: 1px solid $lb-light-gray;

    &--expanded {
      box-shadow: 0 0 1em $lb-gray;
      margin-bottom: 6px;
    }
  }

  &__actions.action-buttons {
    display: flex;
    justify-content: space-between;
    padding: 20px;

    .btn {
      flex: 1 1 50%;
      margin: 0 10px;
      justify-content: center;
      position: relative;

      &:disabled {
        pointer-events: unset;
      }

      .slb-tooltip {
        visibility: hidden;
        opacity: 0;
      }

      &:hover {
        .slb-tooltip {
          opacity: 1;
          visibility: visible;
          transform: translateY(0);
        }
      }

      &.btn-secondary.btn-white:not(:disabled) {
        &.btn-danger,
        &.btn-danger:hover {
          color: $danger;
          border-color: $danger;
          background-color: $lb-white;
        }

        &.btn-danger:focus,
        &.btn-danger:hover {
          box-shadow: 0 5px 10px 0 rgba($danger, 0.5);
        }
      }
    }
  }
}

.publish-modal-modal {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba($lb-dark-gray, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;

  &__content {
    width: 545px;
    display: flex;
    padding: 40px;
    flex-direction: column;
    background-color: $lb-white;
    align-items: center;

    &__header {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      flex-direction: column;
      position: relative;

      h2 {
        font-size: $size-bigger;
        font-weight: $lb-medium;
        line-height: 35px;
        text-align: center;
        letter-spacing: -1px;
        color: $gray-900;
        margin: 40px 0 20px 0;
      }

      .btn-close {
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
      }
    }

    &__text {
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      line-height: 26px;
      color: $gray-900;
      margin-bottom: 20px;

      &__no-errors {
        font-size: $size-normal;
      }

      &__has-errors {
        font-size: $size-small;
      }
    }

    &__buttons {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      width: 70%;
    }
  }
}

.modal {
  z-index: 999999999;
  padding: 1.75rem;
  display: flex;
  background-color: rgba($lb-black, 0.75);

  .modal-dialog {
    margin: auto;
    width: 670px;
    max-width: 100%;
  }
}
</style>
